"use strict";

(function () {
    let isEdit = false;
    const linkType = {
        showEditButton: true,
        itemFields: ["URL", "Icon", "Color", "Description", "Display"],
        addItem(createNewItemCallback) {
            isEdit = "True";
            InitLinkDialog(createNewItemCallback);
        },
        editItem(editTitle, itemFields, dashboardItem, editItemCallback) {
            isEdit = "True";
            InitLinkDialog(editItemCallback, itemFields);
        },
        async onLoaded(dashboardItem, itemFields) {
            const myRequest = new ECP.EC_Request("DashboardWidget_Link");
            myRequest.SetReturnType(ECP.EC_ReturnType.Text);
            const dashboardItemID = dashboardItem.getAttribute("id");
            myRequest.AddRequestVariable("DashboardItemID", dashboardItemID);
            myRequest.AddRequestVariable("URL", itemFields.URL);
            myRequest.AddRequestVariable("Icon", itemFields.Icon);
            myRequest.AddRequestVariable("Color", itemFields.Color);
            myRequest.AddRequestVariable("Description", itemFields.Description);
            myRequest.AddRequestVariable("Display", itemFields.Display);
            myRequest.AddRequestVariable("Edit", isEdit);
            const html = await myRequest.Submit();

            dashboardItem.querySelector(".content").innerHTML = html;
        }
    };

    EWS.DashboardItemTypesManager.add("Link", linkType);
    EWS.DashboardItemTypesManager.add("Tile Link", linkType);
}());

let color;
let title;
let description;
let icon;
let link;
let myDialog;

async function InitLinkDialog(callback, itemFields) {
    const myLinkDialogRequest = new ECP.EC_Request("DashboardWidget_LinkDialog");

    const result = await myLinkDialogRequest.Submit();

    myDialog = ECP.Dialog.ShowDialog(result.title, result.content, {
        width: 500,
        cancelButtonTitle: result.cancel,
        confirmButtonTitle: result.insert,
        cancelButtonAction: () => {
            myDialog.querySelector("#ecp-dashboard-link-icon").value = "";
            myDialog.querySelector("#ecp-dashboard-icon-color").value = "";
            myDialog.querySelector("#ecp-dashboard-link").value = "";

            myDialog.querySelector("#ecp-dashboard-link-title").value = "";
            myDialog.querySelector("#ecp-dashboard-link-description").value = "";

            myDialog.querySelector(".ecp-dashboard-link-icon-list").querySelector(".ecp-dashboard-link-icon-option").style.color = "var(--text-primary)";
            myDialog.classList.remove("ecp-dashboard-link-icon-option-highlight");
        },
        confirmButtonAction: () => {
            title = myDialog.querySelector("#ecp-dashboard-link-title").value;
            description = myDialog.querySelector("#ecp-dashboard-link-description").value;
            link = myDialog.querySelector("#ecp-dashboard-link").value;
            const selected = myDialog.querySelector(".ecp-dashboard-link-icon-list").querySelector(".ecp-dashboard-link-icon-option-highlight");

            if (!link) {
                LinkAlert(myDialog, EC_Fmt.Trn("Please select a link"));
                myDialog.style.display = "block";
                return false;
            }

            if (!title) {
                LinkAlert(myDialog, EC_Fmt.Trn("Please enter a title"));
                myDialog.style.display = "block";
                return false;
            }

            if (!selected || selected.length <= 0) {
                LinkAlert(myDialog, EC_Fmt.Trn("Please select an icon"));
                myDialog.style.display = "block";
                return false;
            }

            selected.classList.remove("ecp-dashboard-link-icon-option-highlight");

            color = selected.style.color;
            icon = selected.getAttribute("icon");

            callback(title, {
                URL: link,
                Icon: icon,
                Color: color,
                Description: description,
                Display: title
            });
            ECP.Dialog.CloseDialog(myDialog);
            return true;
        }
    });

    const iconList = myDialog.querySelector(".ecp-dashboard-link-icon-list");
    const iconOptions = iconList.querySelectorAll(".ecp-dashboard-link-icon-option");

    if (itemFields) {
        link = itemFields.URL;
        icon = itemFields.Icon;
        color = itemFields.Color;
        description = itemFields.Description;
        title = itemFields.Display;
        myDialog.querySelector("#ecp-dashboard-link").value = link;
        myDialog.querySelector("#ecp-dashboard-link-title").value = title;
        myDialog.querySelector("#ecp-dashboard-link-description").value = description;
        iconOptions.forEach((iconOption) => {
            iconOption.style.color = color;
        });

        const iconOption = iconList.querySelector(`.ecp-dashboard-link-icon-option[icon='${icon}']`);
        iconOption.classList.add("ecp-dashboard-link-icon-option-highlight");
        myDialog.querySelector("#ecp-dashboard-link-icon").value = icon;

        setTimeout(() => {
            iconList.scrollTop = iconOption.offsetTop - 40;
        }, 200);
    }

    myDialog.querySelectorAll(".ecp-dashboard-icon-color-list .ecp-dashboard-icon-color-option").forEach((colorOption) => {
        colorOption.addEventListener("click", (event) => {
            const selectedColor = event.currentTarget.style.background;

            iconOptions.forEach((iconOption) => {
                iconOption.style.color = selectedColor;
            });
        });
    });

    iconOptions.forEach((iconOption) => {
        iconOption.addEventListener("click", (event) => {
            const highlighted = iconList.querySelector(".ecp-dashboard-link-icon-option-highlight");
            if (highlighted) {
                highlighted.classList.remove("ecp-dashboard-link-icon-option-highlight");
            }

            event.currentTarget.classList.add("ecp-dashboard-link-icon-option-highlight");

            myDialog.querySelector("#ecp-dashboard-link-icon").value = event.currentTarget.getAttribute("icon");
            myDialog.querySelector("#ecp-dashboard-icon-color").value = EC_Fmt.Color(event.currentTarget.style.color);
        });
    });
}

function LinkAlert(currentDialog, message) {
    const dialog = ECP.Dialog.Alert(message);

    dialog.style.zIndex = parseInt(currentDialog.style.zIndex) + 10;
}
